module.exports = __webpack_public_path__ + "static/media/slrtce.377347bb.png";